export default __webpack_public_path__ + "static/media/features-circle.35930a1c.svg";